import { PrometheusQueryType } from './domain/IPrometheusCanaryMetricSetQueryConfig';
const PROMQL_PREFIX = 'PromQL:';
export function isQueryPromQL(template) {
    return template != null && template.startsWith(PROMQL_PREFIX);
}
export function removePromQLPrefix(template) {
    if (isQueryPromQL(template)) {
        return template.substring(PROMQL_PREFIX.length);
    }
    return template;
}
export function appendPromQLPrefix(template) {
    return `${PROMQL_PREFIX}${template}`;
}
export const getPrometheusQueryType = (editingMetric) => {
    if (editingMetric.query.queryType) {
        return editingMetric.query.queryType;
    }
    const inlineTemplate = editingMetric.query.customInlineTemplate;
    if (isQueryPromQL(inlineTemplate)) {
        return PrometheusQueryType.PROMQL;
    }
    return PrometheusQueryType.DEFAULT;
};
export const prometheusQueryTypeToTransformFunction = {
    [PrometheusQueryType.PROMQL]: {
        fromValue: removePromQLPrefix,
        toValue: appendPromQLPrefix,
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlcnlUeXBlU2VsZWN0b3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2theWVudGEvbWV0cmljU3RvcmUvcHJvbWV0aGV1cy9xdWVyeVR5cGVTZWxlY3RvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLG1CQUFtQixFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFJckYsTUFBTSxhQUFhLEdBQUcsU0FBUyxDQUFDO0FBRWhDLE1BQU0sVUFBVSxhQUFhLENBQUMsUUFBZ0I7SUFDNUMsT0FBTyxRQUFRLElBQUksSUFBSSxJQUFJLFFBQVEsQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLENBQUM7QUFDaEUsQ0FBQztBQUVELE1BQU0sVUFBVSxrQkFBa0IsQ0FBQyxRQUFnQjtJQUNqRCxJQUFJLGFBQWEsQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUMzQixPQUFPLFFBQVEsQ0FBQyxTQUFTLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0tBQ2pEO0lBQ0QsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQztBQUVELE1BQU0sVUFBVSxrQkFBa0IsQ0FBQyxRQUFnQjtJQUNqRCxPQUFPLEdBQUcsYUFBYSxHQUFHLFFBQVEsRUFBRSxDQUFDO0FBQ3ZDLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLGFBQWtDLEVBQUUsRUFBRTtJQUMzRSxJQUFJLGFBQWEsQ0FBQyxLQUFLLENBQUMsU0FBUyxFQUFFO1FBQ2pDLE9BQU8sYUFBYSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUM7S0FDdEM7SUFDRCxNQUFNLGNBQWMsR0FBRyxhQUFhLENBQUMsS0FBSyxDQUFDLG9CQUFvQixDQUFDO0lBQ2hFLElBQUksYUFBYSxDQUFDLGNBQWMsQ0FBQyxFQUFFO1FBQ2pDLE9BQU8sbUJBQW1CLENBQUMsTUFBTSxDQUFDO0tBQ25DO0lBQ0QsT0FBTyxtQkFBbUIsQ0FBQyxPQUFPLENBQUM7QUFDckMsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sc0NBQXNDLEdBQXlEO0lBQzFHLENBQUMsbUJBQW1CLENBQUMsTUFBTSxDQUFDLEVBQUU7UUFDNUIsU0FBUyxFQUFFLGtCQUFrQjtRQUM3QixPQUFPLEVBQUUsa0JBQWtCO0tBQzVCO0NBQ0YsQ0FBQyJ9